import actionTypes from '../actionTypes';

export function setChartDataA(payload) {
	return {
		type: actionTypes.SET_CHART_DATA_A,
		payload,
	};
}

export function setChartDataB(payload) {
	return {
		type: actionTypes.SET_CHART_DATA_B,
		payload,
	};
}

export function setGranularity(payload) {
	return {
		type: actionTypes.SET_GRANULARITY,
		payload,
	};
}

export function setMetricA(payload) {
	return {
		type: actionTypes.SET_METRIC_A,
		payload,
	};
}

export function setMetricB(payload) {
	return {
		type: actionTypes.SET_METRIC_B,
		payload,
	};
}

export function setComparisonChartTimePeriod(payload) {
	return {
		type: actionTypes.SET_COMPARISON_CHART_TIME_PERIOD,
		payload,
	};
}

export function clearMetricA() {
	return {
		type: actionTypes.CLEAR_METRIC_A
	};
}

export function clearMetricB() {
	return {
		type: actionTypes.CLEAR_METRIC_B
	};
}

export function setMetricAErrorStatus() {
	return {
		type: actionTypes.SET_METRIC_A_ERROR_STATUS
	};
}

export function setMetricBErrorStatus() {
	return {
		type: actionTypes.SET_METRIC_B_ERROR_STATUS
	};
}

export function setMetricALoadingStatus(payload) {
	return {
		type: actionTypes.SET_METRIC_A_LOADING_STATUS,
		payload
	};
}

export function setMetricBLoadingStatus(payload) {
	return {
		type: actionTypes.SET_METRIC_B_LOADING_STATUS,
		payload
	};
}

export function setOptionList(payload) {
	return {
		type: actionTypes.SET_PRIMARY_OPTION_LIST,
		payload
	};
}

export function setOptionList2(payload) {
	return {
		type: actionTypes.SET_COMPARISON_OPTION_LIST,
		payload
	};
}
